import styled from "styled-components";

export const RequirementContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const IconWrapper = styled.div<{ $isCompleted: boolean }>`
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${({ theme, $isCompleted }) => $isCompleted ? theme.colors.common.green : theme.colors.text.neutral};
    font-size: 24px;
`;

export const NFTImage = styled.img`
    width: 24px;
    height: 24px;
    border-radius: 4px;
    object-fit: cover;
`;